// extracted by mini-css-extract-plugin
export default {"negativeColor":"#ff4c59","neutralColor":"#d8d8d8","positiveColor":"#08823d","app":"app_WidgetGenerator-module_CARMY","featureTitle":"featureTitle_WidgetGenerator-module_kQHhB"};